import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import i18n from "@Shared/@i18n/";
import LoaderTemplate from "@Shared/@HandlebarsTemplates/general/_loader.hbs";
import DOMPurify from "dompurify";
export default class Loader {
  /**
   * Start spinner on a given container
   * @param {string} container The name of the container
   * @param {string} message Optional message to display
   */
  static start(container, options = {
    message: "",
    overlay: false,
    noFix: false,
    error: false
  }) {
    let {
      message
    } = options;
    const {
      overlay,
      noFix,
      error
    } = options;
    const originalContainer = container;
    if (!$("#main-content").exists()) container = "#body";else if (!$(container).exists()) container = "#main-content";
    const path = DOMPurify.sanitize(window.location.pathname).replace("/", "").replace("#", "");
    const contentClass = container == "#main-content" ? "side-right position-fixed" : "position-absolute";
    const text = (error || $("#main-content").exists() ? "" : i18n.t("global.phrases.loadingYourExperience")) || message;
    if (container !== "#body" && !overlay && !noFix) $(container).addClass("preload-fix");
    const templateData = {
      contentClass,
      path,
      text,
      overlay,
      error
    };
    const {
      preloadContainer
    } = $(originalContainer).data() || {};
    const existingPreload = $(preloadContainer).exists() ? $(preloadContainer).children("#preload") : $("#body").children("#preload");
    if (!error || !existingPreload.exists()) {
      $(originalContainer).data("preload-container", container);
      Loader.stop(originalContainer);
      $(container).append(DOMPurify.sanitize(Loader.template(templateData)));
    } else {
      existingPreload.replaceWith(DOMPurify.sanitize(Loader.template(templateData)));
    }
  }

  /**
   * Remove spinner on a given container
   * @param {string} container
   */
  static stop(container = "body") {
    const target = $(container).data("preload-container") || container;
    if (container === "body") {
      var _context;
      _findInstanceProperty(_context = $(target)).call(_context, "[id=preload]").remove();
    } else {
      $(target).children("[id=preload]").remove();
    }
  }
}
_defineProperty(Loader, "template", LoaderTemplate);